<clr-alert [clrAlertType]="alertType"
           [clrAlertAppLevel]="appLevel"
           [clrAlertClosable]="isAlertClosable">
  <clr-alert-item>
		<span class="alert-text">
      {{alertService.alertConfig.message}}
      <span class="crm-status" *ngIf="showCrmStatus">
        <span class="crm-heart-pulse" *ngIf="crmHealthy">
          <cds-icon class="crm-heart-outline" shape="heart"></cds-icon>
          <cds-icon class="crm-heart-solid" shape="heart" solid></cds-icon>
        </span>
        <cds-icon *ngIf="crmHealthy === false" class="crm-heart-broken" shape="heart-broken"></cds-icon>
        <span class="crm-label">CRM</span>
      </span>
    </span>
  </clr-alert-item>
</clr-alert>
